import ApiService from '../../../core/services/ApiService';

export type BasisMethod = 'tax' | 'gaap' | '704b';

export interface CapitalAccountRow {
  id: string;
  partnerId: string;
  partnerName: string;
  partnerType: 'GP' | 'LP';
  ownershipPercent: number;
  beginningCapital: number;
  contributions: number;
  distributions: number;
  incomeLoss: number;
  endingCapital: number;
}

export interface CapitalSummary {
  basisMethod: BasisMethod;
  taxYear: string;
  rows: CapitalAccountRow[];
  totalBeginning: number;
  totalContributions: number;
  totalDistributions: number;
  totalIncomeLoss: number;
  totalEnding: number;
}

class PriorYearCapitalService extends ApiService {
  getSummary(partnershipId: string, taxYear: string, basisMethod: BasisMethod): Promise<CapitalSummary> {
    return this.makeRequest<CapitalSummary>(
      `/api/prior-year-capital?partnershipId=${partnershipId}&taxYear=${taxYear}&basisMethod=${basisMethod}`,
      { extractData: true },
    );
  }
}

export const priorYearCapitalService = new PriorYearCapitalService();
